const BASE = 'api/spero-sms-service'
const urls = {
  /*
  * body
  *   phone
  * */
  sendSms: 'post /public/sendSms'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS
